// components/table/MaterialTable.jsx (Updated)
import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { LuImagePlus } from "react-icons/lu";
import { FaRegEdit } from "react-icons/fa";
import { RiDeleteBinLine } from "react-icons/ri";
import { MdImageSearch } from "react-icons/md"; // New icon for image management
import { SiCashapp } from "react-icons/si";
import { MdHiking } from "react-icons/md"; // Icon for adventure management

import Popup from "reactjs-popup";
import ButtonComponent from "../button/Button";
import { Cancel } from "axios";
import { Tooltip } from "@mui/material";
import AddForm from "../customForm/AddForm";
// Import the new ImageManagerPopup component
import ImageManagerPopup from "../customForm/ImageManagerPopup";

export default function MaterialTable({
  columns,
  rows,
  deleteFunc,
  deleteLoading,
  updateSchema,
  updateUiSchema,
  updateSubmitFunc,
  route,
  allowImageUpload = false, // This prop controls the existing single image upload via AddForm
  allowImageManagement = false, // New prop to control the new image manager popup
  allowPriceTiering = false, // New prop to control the new price tiering popup
  allowAdventureManagement = false, // New prop to control adventure management
  imageSchema, // This is for the AddForm component, not directly for ImageManagerPopup
  imageUiSchema, // This is for the AddForm component, not directly for ImageManagerPopup
  priceSchema, // This is for the AddForm component, not directly for ImageManagerPopup
  priceUiSchema, // This is for the AddForm component, not directly for ImageManagerPopup
  adventureSchema, // Schema for adventure management
  adventureUiSchema, // UI Schema for adventure management
  handleImageUpload, // This is for the AddForm component, not directly for ImageManagerPopup
  handlePriceUpdate,
  handleAdventureUpdate, // Handler for adventure updates
  title,
  subtitle,
}) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  // We'll manage a specific state for the image manager popup
  const [imageManagerPopupOpen, setImageManagerPopupOpen] =
    React.useState(false);
  const [
    selectedRowNameForImageManagement,
    setSelectedRowNameForImageManagement,
  ] = React.useState(null);
  const [selectedRowIdForImageManagement, setSelectedRowIdForImageManagement] =
    React.useState(null);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleOpenImageManager = (rowId, rowName) => {
    console.log(rowName);
    setSelectedRowIdForImageManagement(rowId);
    setSelectedRowNameForImageManagement(rowName);
    setImageManagerPopupOpen(true);
  };

  const handleCloseImageManager = () => {
    setSelectedRowIdForImageManagement(null);
    setImageManagerPopupOpen(false);
  };

  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer sx={{}}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead sx={{ backgroundColor: "blue" }}>
            <TableRow style={{ backgroundColor: "blue" }}>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{
                    fontWeight: "bold",
                    fontSize: 15,
                    color: "white",
                    backgroundColor: "#201F5B",
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
              {/* <TableCell // Add a header for the actions column
                key="actions"
                align="center"
                style={{
                  fontWeight: "bold",
                  fontSize: 15,
                  color: "white",
                  backgroundColor: "#201F5B",
                }}
              >
                Actions
              </TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => {
              return (
                <TableRow
                  hover
                  role="checkbox"
                  tabIndex={-1}
                  key={row.rawData.id}
                >
                  {" "}
                  {/* Changed to row.rawData.id for consistent keying */}
                  {row.data.map((cell, index) => (
                    <TableCell key={index} style={{ fontSize: 15 }}>
                      {cell}
                    </TableCell>
                  ))}
                  <TableCell key={999}>
                    <div className="flex space-x-4">
                      {/* New button for Image Management Popup */}
                      {allowImageManagement && (
                        <div>
                          <Tooltip title="Manage Images">
                            <button
                              onClick={() =>
                                handleOpenImageManager(
                                  row.rawData.id,
                                  row.rawData?.name
                                )
                              }
                            >
                              <MdImageSearch color="purple" size={20} />
                            </button>
                          </Tooltip>
                        </div>
                      )}

                      {/* Existing Image Upload (if applicable for single image) */}
                      {allowImageUpload && (
                        <div>
                          <Popup
                            trigger={
                              <button>
                                <LuImagePlus color="green" size={20} />
                              </button>
                            }
                            position="left top"
                            contentStyle={{
                              borderRadius: 10,
                              overflow: "auto",
                              maxHeight: "90%",
                              minWidth: "60%",
                            }}
                          >
                            {(close) => (
                              <div>
                                <AddForm
                                  title={`Upload ${title} Image`}
                                  subtitle={`Uploading ${subtitle} Image`}
                                  close={close}
                                  schema={imageSchema}
                                  uischema={imageUiSchema}
                                  initialData={{ id: row.rawData?.id }}
                                  handleSubmit={handleImageUpload}
                                  actionName="Upload"
                                />
                              </div>
                            )}
                          </Popup>
                        </div>
                      )}

                      {/* ADD TIER PRICING */}
                      {allowPriceTiering && (
                        <div>
                          <Popup
                            trigger={
                              <button>
                                <SiCashapp color="brown" size={20} />
                              </button>
                            }
                            position="left top"
                            contentStyle={{
                              borderRadius: 10,
                              overflow: "auto",
                              maxHeight: "90%",
                              minWidth: "60%",
                            }}
                          >
                            {(close) => (
                              <div>
                                <AddForm
                                  title={`Add ${title} Price Tier`}
                                  subtitle={`Add ${subtitle} Price Tier`}
                                  close={close}
                                  schema={priceSchema}
                                  uischema={priceUiSchema}
                                  initialData={{ id: row.rawData?.id }}
                                  handleSubmit={handlePriceUpdate}
                                  actionName="Add"
                                />
                              </div>
                            )}
                          </Popup>
                        </div>
                      )}

                      {/* ADVENTURE MANAGEMENT */}
                      {allowAdventureManagement && (
                        <div>
                          <Popup
                            trigger={
                              <Tooltip title="Manage Adventures">
                                <button>
                                  <MdHiking color="orange" size={20} />
                                </button>
                              </Tooltip>
                            }
                            position="left top"
                            contentStyle={{
                              borderRadius: 10,
                              overflow: "auto",
                              maxHeight: "90%",
                              minWidth: "60%",
                            }}
                          >
                            {(close) => (
                              <div>
                                <AddForm
                                  title={`Manage ${title} Adventures`}
                                  subtitle={`Managing Adventures for ${
                                    row.rawData?.name || subtitle
                                  }`}
                                  close={close}
                                  schema={adventureSchema}
                                  uischema={adventureUiSchema}
                                  initialData={{
                                    programmeId: row.rawData?.id,
                                    programmeName: row.rawData?.name,
                                    adventures:
                                      row.rawData?.adventureIds ||
                                      row.rawData?.adventures ||
                                      [],
                                  }}
                                  handleSubmit={handleAdventureUpdate}
                                  actionName="Update"
                                />
                              </div>
                            )}
                          </Popup>
                        </div>
                      )}

                      <div>
                        <Popup
                          trigger={
                            <button>
                              <FaRegEdit color="blue" size={20} />
                            </button>
                          }
                          position="left top"
                          contentStyle={{
                            borderRadius: 10,
                            overflow: "auto",
                            maxHeight: "90%",
                            minWidth: "60%",
                          }}
                        >
                          {(close) => (
                            <div>
                              <AddForm
                                title={`Update ${title}`}
                                subtitle={`Updating ${subtitle}`}
                                close={close}
                                schema={updateSchema}
                                uischema={updateUiSchema}
                                initialData={row.rawData}
                                handleSubmit={updateSubmitFunc}
                                actionName="Update"
                              />
                            </div>
                          )}
                        </Popup>
                      </div>

                      <div>
                        <Popup
                          trigger={
                            <button>
                              <RiDeleteBinLine color="red" size={20} />
                            </button>
                          }
                          position="left center"
                          // open={openPopup} // This was causing issues, better to control open state explicitly if needed
                        >
                          {(close) => (
                            <div className="px-16 py-10">
                              {/* Delete model Top */}
                              <div>
                                <div className="text-4xl text-red-500 font-semibold">
                                  Delete {route}
                                </div>
                              </div>

                              {/* MODAL Content */}
                              <div className="my-5">
                                <div>
                                  Are you sure you want to delete this
                                  {` ${route.toLowerCase()}`}?
                                </div>
                              </div>

                              {/* BUTTONS */}
                              <div className="flex space-x-5">
                                <div onClick={close}>
                                  <ButtonComponent
                                    name={"Cancel"}
                                    type={"cancel"}
                                  />
                                </div>
                                <div
                                  onClick={() =>
                                    deleteFunc(row.rawData.id, close)
                                  }
                                >
                                  <ButtonComponent
                                    name={"Delete"}
                                    type={"delete"}
                                    disabled={deleteLoading}
                                  />
                                </div>

                                {deleteLoading && <div>Loading...</div>}
                              </div>
                            </div>
                          )}
                        </Popup>
                      </div>
                    </div>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Image Manager Popup for a specific row */}
      <Popup
        open={imageManagerPopupOpen}
        onClose={handleCloseImageManager}
        position="center center"
        modal
        contentStyle={{
          borderRadius: 10,
          overflow: "auto",
          maxHeight: "90%",
          minWidth: "70%", // Adjust width as needed
        }}
      >
        {(close) => (
          <ImageManagerPopup
            rowId={selectedRowIdForImageManagement}
            close={handleCloseImageManager} // Pass the close handler
            title={selectedRowNameForImageManagement}
            subtitle={subtitle}
          />
        )}
      </Popup>

      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
